import { useEffect, useState } from 'react';
import { Sidebar } from './components/Sidebar/Sidebar';
import { MapView } from './components/Map/MapView';
import { RadarPointPanel } from './components/RadarPointPanel/RadarPointPanel';
import { PolygonPanel } from './components/PolygonPanel/PolygonPanel';
import { Topbar } from './components/Layout/Topbar';
import { Toast } from './components/ui/Toast';
import { useAppState } from './state/appState';
import { api } from './api/client';
import type { HealthResponse } from './types';
import './components/Layout/Layout.css';

export default function App() {
  const state = useAppState();
  const [health, setHealth] = useState<HealthResponse | null>(null);

  useEffect(() => {
    api.health().then(setHealth).catch(() => setHealth(null));
  }, []);

  return (
    <div className="app-shell">
      <Topbar health={health} />
      <div className="app-body">
        <Sidebar state={state} />
        <div className="map-and-panel">
          <MapView state={state} />
          <PolygonPanel state={state} />
        </div>
      </div>
      {state.selectedPointId && (
        <RadarPointPanel
          pointId={state.selectedPointId}
          point={state.radarPoints.find((p) => p.point_id === state.selectedPointId)}
          filters={state.filters}
          polygonResult={state.polygonResult}
          onClose={() => state.setSelectedPointId(null)}
        />
      )}
      {state.error && (
        <Toast kind="error" onDismiss={() => state.setError(null)}>
          {state.error}
        </Toast>
      )}
    </div>
  );
}

